export enum AudienceFilterType {
  AllConsumers = 'allConsumers',
  TopConsumers = 'topConsumers',
  WinBack = 'winBack',
}

export type RankingMetric = 'visitCount' | 'totalSpend';
export type AudienceSizeType = 'top10' | 'top20' | 'custom';
export type DateRangePreset = 'last90days' | 'last30days' | 'allTime' | 'custom';
export type WinBackPeriod = '30days' | '60days' | '90days';

export interface AllConsumersFilterConfig {}

export interface TopConsumersFilterConfig {
  rankingMetric: RankingMetric;
  audienceSizeType: AudienceSizeType;
  customCount: number | null;
  dateRangePreset: DateRangePreset;
  dateRangeStart: Date | string | null;
  dateRangeEnd: Date | string | null;
}

export interface WinBackFilterConfig {
  inactivityPeriod: WinBackPeriod;
}

export type AudienceFilterConfig =
  | AllConsumersFilterConfig
  | TopConsumersFilterConfig
  | WinBackFilterConfig
  | Record<string, unknown>;

export interface AudienceFilter {
  filterType: AudienceFilterType;
  config: AudienceFilterConfig;
}
